









































import { computed, defineComponent, ref } from "@vue/composition-api";

interface Props {
  value: string;
  options: string[];
}

export default defineComponent<Props>({
  name: "PredictiveInput",
  props: {
    value: { type: String, required: true },
    options: { type: Array, required: true }
  },
  setup(props: Props) {
    const index = ref(0);

    const isExpanded = ref(false);

    const filtered = computed(() =>
      props.options.filter(option =>
        option.toLocaleLowerCase().includes(props.value.toLocaleLowerCase())
      )
    );

    return { filtered, index, isExpanded };
  }
});
